exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "svg[data-v-c74df43c]{max-width:100%}", ""]);

